'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _dec,_desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const Group=require('../../../../../dist-es6/server/domain/group');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../dist-es6/client/dtos/socketResponse');let

EditGroupModalController=(_dec=













































HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=function(_BaseController){_inherits(EditGroupModalController,_BaseController);_createClass(EditGroupModalController,null,[{key:'$inject',get:function(){return['$modalInstance','resolvedParameters','uncaughtErrorHandler','$modal','uiCommandFactory','socketService','groupUpdateErrorHandlingService']}}]);function EditGroupModalController($modalInstance,resolvedParameters,uncaughtErrorHandler,$modal,uiCommandFactory,socketService,groupUpdateErrorHandlingService){_classCallCheck(this,EditGroupModalController);var _this=_possibleConstructorReturn(this,_BaseController.call(this,uncaughtErrorHandler));_this._$modalInstance=$modalInstance;_this._$modal=$modal;_this._group=resolvedParameters.group;_this._updatedName=resolvedParameters.group.name;_this._onGroupSaved=resolvedParameters.onGroupSaved;_this._onGroupDeleted=resolvedParameters.onGroupDeleted;_this._socketService=socketService;_this._groupUpdateErrorHandlingService=groupUpdateErrorHandlingService;_this._saveGroupCommand=uiCommandFactory.makeForModal($modalInstance,function(){return _this._saveGroup()});_this._saveErrors=[];return _this}EditGroupModalController.prototype.deleteGroup=function deleteGroup(){var _this2=this;this._$modalInstance.dismiss();let modalInstance=this._$modal.open({templateUrl:'/templates/features/groups/modals/deleteGroupModalView',controller:'DeleteGroupModalController as controller',resolve:{resolvedParameters:function(){return{group:_this2._group,onGroupDeleted:_this2._onGroupDeleted}}}})};EditGroupModalController.prototype.
_saveGroup=function(){var ref=_asyncToGenerator(function*(){
this._saveErrors=[];

const response=yield this._socketService.sendAndWaitForResponse('RenameGroup',{groupId:this._group.id,name:this.updatedName});

if(!SocketResponse.succeeded(response)){
if(response.status==='HttpError'&&response.body.httpStatus===422){
const newNameLength=this.updatedName.trim().length;
if(newNameLength<Group.MinNameLength||newNameLength>Group.MaxNameLength){
this._saveErrors=[`Name must contain between ${Group.MinNameLength} and ${Group.MaxNameLength} characters.`];
return ModalSubmissionResult.KeepOpen;
}

this._saveErrors=response.body.errors;
return ModalSubmissionResult.KeepOpen;
}

this._groupUpdateErrorHandlingService.handle(response);
}

yield this._onGroupSaved(this._group.id);

return ModalSubmissionResult.Close();
});function _saveGroup(){return ref.apply(this,arguments)}return _saveGroup}();EditGroupModalController.prototype.

onCancel=function onCancel(){
this._$modalInstance.dismiss();
};_createClass(EditGroupModalController,[{key:'saveGroupCommand',get:function(){return this._saveGroupCommand}},{key:'saveErrors',get:function(){return this._saveErrors}},{key:'updatedName',get:function()

{
return this._updatedName||'';
},set:function(

updatedName){
this._updatedName=updatedName;
}}]);return EditGroupModalController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_saveGroup',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_saveGroup'),_class.prototype)),_class));


module.exports=EditGroupModalController;
//# sourceMappingURL=editGroupModalController.js.map
